import { render, staticRenderFns } from "./updateuserinfo.vue?vue&type=template&id=5353a9be&scoped=true"
import script from "./updateuserinfo.vue?vue&type=script&lang=js"
export * from "./updateuserinfo.vue?vue&type=script&lang=js"
import style0 from "./updateuserinfo.vue?vue&type=style&index=0&id=5353a9be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5353a9be",
  null
  
)

export default component.exports